<template>
	<div>
		<action-sidebar
			:title="title"
			:value="true"
			@close-modal="closeModal"
		>
			<role-form
				:role-id="id"
			 	:code-company="codeCompany"
			 	:code-project="codeProject"
			/>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import roleForm from '@/components/roles/role-form';

function closeModal() {
	this.goTo('page-role', { params: { codeCompany: this.codeCompany, codeProject: this.codeProject } });
}

function title() {
	const rol = 'Rol';
	return this.id ? `Editar ${rol}` : `Crear ${rol}`;
}

export default {
	name: 'page-role-new',
	components: {
		actionSidebar,
		roleForm,
	},
	computed: {
		title,
	},
	methods: {
		closeModal,
	},
	props: {
		codeCompany: {
			type: String,
			required: true,
		},
		codeProject: {
			type: String,
			required: true,
		},
		id: {
			type: [Number, String],
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/roles/page-role-new.vue